import '../assets/css/MyGame.css';
import '../assets/css/GameList.css';
import '../../src/assets/css/GameCard.css';
import { useNavigate } from "react-router-dom";
import { IoPeopleOutline } from "react-icons/io5";
import { IoLocationOutline } from "react-icons/io5";
import { FaDollarSign } from "react-icons/fa6";
import TennisBallImg from '../assets/icons/tennisballImg.png';
import PickleBallImg from '../assets/icons/picklebal.png';
import { MdDateRange } from "react-icons/md";


const GameCard = ({ LeaveButton, gameData }) => {

    const formatDateTime = (startTime, endTime) => {
        const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
            "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

        const parseDateTime = (dateTimeStr) => {
            const [datePart, timePart] = dateTimeStr.split(" ");
            const [day, month, year] = datePart.split("-").map(Number);
            const [hour, min] = timePart.split(":").map(Number);
            return {
                date: new Date(year, month - 1, day, hour, min),
                hour,
                min,
                day,
                month,
            };
        };

        const start = parseDateTime(startTime);
        const end = parseDateTime(endTime);

        const formattedDate = `${start.day} ${months[start.month - 1]}`;
        const formattedStart = `${String(start.hour).padStart(2, "0")}:${String(start.min).padStart(2, "0")}`;
        const formattedEnd = `${String(end.hour).padStart(2, "0")}:${String(end.min).padStart(2, "0")}`;

        return `${formattedDate}, ${formattedStart} - ${formattedEnd}`;
    };

    const gameAbout = [
        { icon: <IoPeopleOutline className='game-card-con-icon' />, text: `${gameData?.requiredPlayers - gameData?.currentPlayers} slots available` },
        { icon: <IoLocationOutline className='game-card-con-icon' />, text: gameData?.courtName },
        { icon: <IoPeopleOutline className='game-card-con-icon' />, text: `${gameData?.currentPlayers} players` },
        { icon: <FaDollarSign className='game-card-con-icon' />, text: `${gameData?.courtPrice == null || 0 || '0' ? "Free" : gameData?.courtPrice + ' $ per player'}` },
        { icon: <IoLocationOutline className='game-card-con-icon' />, text: ` ${gameData?.distance !== undefined ? (gameData?.distance / 1609.34).toFixed(2) : 0} miles` },
        { icon: <MdDateRange className='game-card-con-icon' /> , text: formatDateTime(gameData.startTime, gameData.endTime) },
    ];

    const navigate = useNavigate();

    const gameDetail = (gameId, gameStatus) => {
        gameStatus.toLowerCase() == 'draft' ?
            navigate('/createGame', { state:{ gameData : gameData }})
            :
            navigate(`/mygamejoined/${gameId}`, { state: { isRequested: gameData.isRequested, isWaitingPlayer: gameData.isWaitingPlayer, sportNames: gameData.sportName, hostName: gameData?.host || gameData?.hostName } })
    };

    const getSportIcon = (sportName) => {
        return sportName.toLowerCase() == 'tennis' ? TennisBallImg : PickleBallImg;
    };

    return (
        <div className={` game-card-container ${gameData?.status == 'DRAFT' ? 'bg-light-draft' : gameData?.status == 'ACTIVE' ? 'bg-soft-yellow' : gameData.status == 'COMPLETED' ? 'bg-light-blue' : 'bg-light-blue'}`} onClick={() => gameDetail(gameData.gameId, gameData.status)}>
            <div className='d-flex justify-content-between align-items-center'>
                <div className='game-card-name'>
                    <img src={getSportIcon(gameData?.sportName)} className="game-card-ball-icon" alt="Game Icon" />
                    <span className='game-name-text'>{gameData?.gameName}</span>
                </div>
                <div className='game-card-singles-text'>{gameData?.singularity.charAt(0).toUpperCase() + gameData?.singularity.slice(1).toLowerCase()}</div>
            </div>
            <div className='row mt-1 sm-mt-3 ps-0 sm-ps-2'>
                <div className="col-lg-12">
                    <div className="row game-about-wrapper">
                        {gameAbout?.map((about, index) => (
                            <div key={index} className='col-6'>
                                <div className='game-card-icon-txt mb-0 sm:mb-2'>
                                    <span>{about?.icon}</span>
                                    <span className='game-about-text'>{about?.text}</span>
                                    <span className="game-about-text"> {about?.time}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className='row align-items-center  mt-1 sm-mt-3 mb-2'>
                <div className='col-8'>
                    <div className=" game-level-sport-container d-flex">
                        <div className=" level-sports me-3">
                            <div className="custom-beginer-button approve-or-deny-beginner px text-upper text-center">{gameData?.level}</div>
                        </div>
                        <div className=" sports-name">
                            <div className="custom-beginer-button approve-or-deny-beginner px text-upper text-center">{gameData?.sportName?.toUpperCase()}</div>
                        </div>
                    </div>
                </div>
                <div className={`col-4 game-card-slot text-end ${gameData?.status === 'ACTIVE' ? 'game-card-list-active' : gameData.status == "DRAFT" ? 'color-golden-yellow ' : gameData.status == "COMPLETED" ? 'color-bright-blue' : 'color-dark-gray'}`}>
                    <span className={` game-card-circle-active ${gameData?.status === 'ACTIVE' ? 'bg-neon-green' : gameData.status == "DRAFT" ? 'bg-golden-yellow ' : gameData.status == "COMPLETED" ? 'bg-bright-blue' : 'bg-dark-gray'}`}></span>{gameData?.status.charAt(0).toUpperCase() + gameData.status.slice(1).toLowerCase()}
                </div>
            </div>
            <div className='row text-center mt-1 mt-sm-3'>
                <div className={` ${ LeaveButton ? 'col-7' : 'col-12'  } col-sm-6 col-lg-6 game-card-slot text-start ps-sm-3 `}>
                    <div className='game-card-con-host py-sm-1 ps-sm-2'>Host: {gameData?.host || gameData?.hostName}</div>
                </div>
                <div className='col-5 col-sm-6 col-lg-6 d-flex justify-content-end h-50' onClick={(e) => e.stopPropagation()}>
                    {LeaveButton}
                </div>

            </div>
        </div>
    );
};

export default GameCard;

